import React, {useState, useEffect} from 'react';

//import {Modal, Button} from 'react-bootstrap';

//import 'bootstrap/dist/css/bootstrap.min.css';

const DeleteConfirmPopup = ({toggleDeleteShow, btnCancel, btnDelete, txtModalHeader, txtModalContent, btndeletespin}) =>{

    //const [show, setShow] = useState(false);
    

    return(
    <>
    <div className={toggleDeleteShow ? 'modal fade show' : 'modal fade' } id="exampleModalScrollable2" tabindex="-1" aria-labelledby="exampleModalScrollable2" data-bs-keyboard="false" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="staticBackdropLabel2">{txtModalHeader}</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={btnCancel}></button>
                </div>
                <div class="modal-body">
                    <p>{txtModalContent}</p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-cancel" data-bs-dismiss="modal" onClick={btnCancel}>Close</button>

                    {btndeletespin ?
                        <button type="button" class="btn btn-primary"> 
                            <div className="spinner-border" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                        </button>
                    :
                        <button type="button" class="btn btn-primary" onClick={btnDelete}> Delete </button>
                    }
                </div>
            </div>
        </div>
    </div>
    {/*<Modal show={toggleDeleteShow} onHide={btnCancel} centered>

        <Modal.Header closeButton>

          <Modal.Title>{txtModalHeader}</Modal.Title>

        </Modal.Header>
        
        <Modal.Body>
                <p>{txtModalContent}</p>

        </Modal.Body>

        <Modal.Footer>
            <Button variant="secondary" onClick={btnCancel}> Cancel </Button>

            {btndeletespin ?
                <Button variant="primary"> 
                    <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </Button>
            :
                <Button variant="primary" onClick={btnDelete}> Delete </Button>
            }

        </Modal.Footer>
      </Modal>*/}
      </>
    );
}

export default DeleteConfirmPopup;
